import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from 'vue-toastification'
import { VueMaskDirective } from 'v-mask'
import router from './router'
import App from './App.vue'

// Styles
import './style.css'
import 'vue-toastification/dist/index.css'

const app = createApp(App)
const pinia = createPinia()

// Configure Toast
const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

app.use(pinia)
app.use(router)
app.use(Toast, toastOptions)
app.directive('mask', VueMaskDirective)

app.mount('#app')
